<div class="flex-header mat-dialog-title">
    <span *ngIf="newFile" translate>Add Document</span>
    <span *ngIf="!newFile" translate>Edit Document</span>
</div>
<div class="flex-content">
    <div>
        <tyl-form-field label="File Name" style="width: 500px;" hint="{{100 - (fileNameString ? fileNameString.length : 0)}} characters left">
            <textarea matInput #fileNameInput [(ngModel)]="fileNameString" maxlength="100" id="fileNameInput" name="FileName"
                required rows="2" style="resize: none;">
            </textarea>
        </tyl-form-field>
    </div>
    <div>
        <tyl-form-field label="Description" style="width: 100%;" hint="{{500 - (descriptionString ? descriptionString.length : 0)}} characters left">
            <textarea matInput #descriptionInput [(ngModel)]="descriptionString" maxlength="500" id="DescriptionInput"
                name="Description" rows="6" style="resize: none;">
            </textarea>
        </tyl-form-field>
    </div>
    <div>
        <tyl-form-field label="Document Type">
            <mat-select #documentTypeInput [(ngModel)]="documentTypeIdString" name="DocumentType" id="documentTypeSelect" required>
                <mat-option *ngFor="let type of documentTypes; let i = index" value="{{type.Id}}">
                    <span>{{type.CodeDescription}}</span>
                </mat-option>
            </mat-select>
        </tyl-form-field>
    </div>
    <div style="padding-bottom: 10px" *ngIf="newFile">
        <add-file [buttonLabel]="'Browse'" [required]="true" (changes)="addFileChanges($event)"></add-file>
        <div *ngIf="fileError == true" style="color: #b71c1c; font-size: 75%; padding-left: 10px" translate>
            Please select a file
        </div>
    </div>
</div>
<div class="flex-footer">
    <div class="flex-footer-right">
        <error-prompt [errorList]="errors"></error-prompt>
        <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()" translate></tyl-button>
        <tyl-button image="cancel.png" label="Cancel" (clickEvent)="closeClick()" translate></tyl-button>
    </div>
</div>
